export default from './member-header';



// WEBPACK FOOTER //
// ./app/components/member-header/index.js